import { buildLegalDocumentHtml } from '@/features/auth/components/legal/legal-document-html';

/**
 * Sample Terms of Service copy rendered in the legal popup. This is placeholder
 * data — swap the body for the production legal text when it is finalised.
 */
export const TERMS_OF_SERVICE_HTML = buildLegalDocumentHtml(`
    <section>
      <h2>Acceptance of terms</h2>
      <p>
        By creating an account or using the U.S. Kids Golf Player Pathway app, you agree to be bound
        by these Terms of Service. If you do not agree to these terms, please do not use the app.
      </p>
    </section>

    <section>
      <h2>Using the app</h2>
      <ul>
        <li>You must be at least 18 years old, or have the consent of a parent or legal guardian.</li>
        <li>You are responsible for keeping your account credentials secure and confidential.</li>
        <li>You agree to provide accurate information and to keep it up to date.</li>
        <li>You may not use the app for any unlawful purpose or in a way that harms other users.</li>
      </ul>
    </section>

    <section>
      <h2>Accounts and guardians</h2>
      <p>
        Guardian accounts may add and manage player profiles for the children in their care. You are
        responsible for all activity that takes place under your account and any linked player
        profiles, and for ensuring you have the right to share information about those players.
      </p>
    </section>

    <section>
      <h2>Content and data</h2>
      <p>
        Scores, sessions, tournament results and other content you submit remain yours. By
        submitting content you grant us a limited licence to store, display and process it so we can
        provide the service — for example to calculate progress and rankings.
      </p>
    </section>

    <section>
      <h2>Service availability</h2>
      <p>
        We work hard to keep the app available, but we provide it on an "as is" and "as available"
        basis. We may update, suspend or discontinue features at any time, and we are not liable for
        any loss arising from interruptions or changes to the service.
      </p>
    </section>

    <section>
      <h2>Termination</h2>
      <p>
        We may suspend or terminate your access if you breach these terms. You may stop using the
        app and request deletion of your account at any time by contacting
        <a href="mailto:coach@uskidsgolf.com">coach@uskidsgolf.com</a>.
      </p>
    </section>

    <section>
      <h2>Changes to these terms</h2>
      <p>
        We may revise these Terms of Service from time to time. When we do, we will update the date
        below and, where appropriate, notify you in the app. Continued use of the app after changes
        take effect means you accept the revised terms.
      </p>
      <p class="muted">Last updated: June 2026</p>
    </section>
`);

export default TERMS_OF_SERVICE_HTML;
